// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xProductPartNumbersStyles from "@steiner/App/SharedStyles/ProductPartNumbersStyles";
import { customerPartNumberStyles } from "@steiner/Overrides/Widgets/ProductDetails/ProductDetailsCustomerPartNumber";
import Edit from "@steiner/XDL/Icons/Edit";
import Plus from "@steiner/XDL/Icons/Plus";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { mergeWithCss, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

customerPartNumberStyles.labelText = {
    ...xProductPartNumbersStyles.label,
    size: 14,
    lineHeight: "22px",
    weight: fontConfig.weight.regular,
};

customerPartNumberStyles.valueText = {
    ...mergeWithCss(xProductPartNumbersStyles.value, {
        css: css`
            margin-right: 12px;
        `,
    }),
    size: 14,
    lineHeight: "22px",
    weight: fontConfig.weight.bold,
};

customerPartNumberStyles.addCpnButton = {
    icon: {
        iconProps: {
            src: Plus,
            size: 12,
            css: css`
                opacity: 0.66;
            `,
        },
    },
    typographyProps: {
        size: fontConfig.fontSize.xSmall,
        lineHeight: fontConfig.lineHeight.xSmall,
    },
};

customerPartNumberStyles.editForm = {
    css: css`
        display: flex;
        gap: 8px;
    `,
};

customerPartNumberStyles.cpnField = {
    cssOverrides: {
        formField: css`
            flex-direction: row;
            align-items: center;
            label {
                width: auto;
                margin-right: 5px;
            }
            ${xScreen("lte", "md")} {
                width: auto;
            }
        `,
        formInputWrapper: css`
            width: 100px;
            &&&& {
                margin-top: 0;
            }
        `,
    },
};

customerPartNumberStyles.valueContainer = {
    css: css`
        display: flex;
        ${xScreen("lte", 900)} {
            flex-wrap: wrap;
        }
    `,
};

customerPartNumberStyles.editCpnButton = {
    icon: {
        iconProps: {
            src: Edit,
            size: 12,
            css: css`
                opacity: 0.66;
            `,
        },
    },
    typographyProps: {
        size: 12,
        lineHeight: "15px",
    },
};
